module.exports = __webpack_public_path__ + "static/construction-worker-c20e1aab5f888d9c41b3c45684500136.jpg";